(function () {
  // Checkout Champ builds the cart from ?products=ID:QTY;ID:QTY on the funnel's checkout page.
  // IDs captured from the live /vb/sp buy box (2026-09-29): 68/69/70 = bundles, 92 = shipping
  // insurance, which the live page adds by default.
  // Pages can override per product: <body data-checkout="..." data-products='{"Buy One":61,...}'>
  // (Boneflex: /bf/checkout, 61/62/63). Defaults are Vital Bull.
  var CHECKOUT_URL = document.body.dataset.checkout || "https://shop.lonvera.com/vb/checkout";
  var PRODUCT_IDS = document.body.dataset.products ? JSON.parse(document.body.dataset.products)
    : { "Buy One": 68, "Buy 2 Get 1 Free": 69, "Buy 3 Get 2 Free": 70 };
  var ADDONS = "92:1";

  // Ships-by date: next business day.
  var d = new Date();
  do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
  var ship = d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  document.querySelectorAll(".js-shipdate").forEach(function (el) { el.textContent = ship; });
  var shipLong = d.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" });
  document.querySelectorAll(".js-shipdate-long").forEach(function (el) { el.textContent = shipLong; });

  // Gallery
  var track = document.getElementById("track");
  var thumbs = document.getElementById("thumbs");
  var slides = Array.prototype.slice.call(track.children);
  slides.forEach(function (img, i) {
    var b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", "Show image " + (i + 1));
    b.innerHTML = '<img src="' + img.getAttribute("src") + '" alt="" loading="lazy">';
    b.addEventListener("click", function () { track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" }); });
    thumbs.appendChild(b);
  });
  function markThumb() {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    Array.prototype.forEach.call(thumbs.children, function (t, j) { t.setAttribute("aria-current", j === i ? "true" : "false"); });
  }
  track.addEventListener("scroll", function () { window.requestAnimationFrame(markThumb); }, { passive: true });
  markThumb();

  // Bundle radiogroup
  var group = document.getElementById("bundles");
  var opts = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
  var sbName = document.getElementById("sb-name");
  var sbPrice = document.getElementById("sb-price");
  function select(o, focus) {
    opts.forEach(function (x) { var on = x === o; x.setAttribute("aria-checked", on); x.tabIndex = on ? 0 : -1; });
    sbName.textContent = o.dataset.name;
    sbPrice.textContent = o.dataset.price;
    if (focus) o.focus();
  }
  opts.forEach(function (o, i) {
    o.addEventListener("click", function () { select(o); });
    o.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); select(opts[(i + 1) % opts.length], true); }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); select(opts[(i - 1 + opts.length) % opts.length], true); }
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); select(o); }
    });
  });

  // ABSolutely start
  function getStorageValue(key) {
    const value = localStorage.getItem(key);
    if (!value) return null;
    try {
      let parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.join(',');
      }
      if (parsed && typeof parsed === 'object') {
        return Object.keys(parsed).map(function (id) {
          return parsed[id];
        }).join(',');
      }
    } catch (e) {
      return value;
    }
    return value;
  }

  function getAbsParams() {
    let absParams = '';
    function addAbsParam(name, value) {
      if (value) {
        absParams += '&' + name + '=' + encodeURIComponent(value);
      }
    }
    addAbsParam('cc_custom__abs_id', getStorageValue('abs-id'));
    addAbsParam('cc_custom__abs_groups', getStorageValue('abs-test-groups'));
    addAbsParam('cc_custom__abs_shipping_groups', getStorageValue('abs-shipping-test-groups'));
    addAbsParam('cc_custom__abs_redirect_groups', getStorageValue('abs-redirect-test-groups'));
    addAbsParam('cc_custom__abs_theme_groups', getStorageValue('abs-theme-test-groups'));
    addAbsParam('cc_custom__abs_template_groups', getStorageValue('abs-template-test-groups'));
    return absParams;
  }

  document.querySelectorAll(".js-atc").forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      var sel = group.querySelector('[aria-checked="true"]');
      // Carry the ad click's tracking params (fbclid, utm_*) through to checkout for attribution.
      var params = new URLSearchParams(window.location.search);
      params.set("products", PRODUCT_IDS[sel.dataset.name] + ":1;" + ADDONS);
      window.location.href = CHECKOUT_URL + "?" + params.toString().replace(/%3A/g, ":").replace(/%3B/g, ";") + getAbsParams();
    });
  });

  // ABSolutely end

  // Sticky buy bar once the main CTA scrolls away
  var bar = document.getElementById("stickybar");
  var atc = document.getElementById("atc");
  var pricing = document.getElementById("pricing");
  if ("IntersectionObserver" in window) {
    var atcVisible = true, heroVisible = true;
    var update = function () { var on = !atcVisible && !heroVisible; bar.classList.toggle("is-on", on); bar.setAttribute("aria-hidden", on ? "false" : "true"); };
    new IntersectionObserver(function (es) { atcVisible = es[0].isIntersecting; update(); }).observe(atc);
    new IntersectionObserver(function (es) { heroVisible = es[0].isIntersecting && es[0].boundingClientRect.top > -200; update(); }, { threshold: [0, 0.2] }).observe(pricing);
  }

  // UGC video modal
  var modal = document.getElementById("vmodal");
  var player = document.getElementById("vplayer");
  function close() { player.pause(); player.removeAttribute("src"); player.load(); modal.hidden = true; }
  document.querySelectorAll(".ugc__card").forEach(function (c) {
    c.addEventListener("click", function () {
      player.src = c.dataset.src;
      player.poster = c.querySelector("img").src;
      modal.hidden = false;
      player.play().catch(function () {});
    });
  });
  modal.addEventListener("click", function (e) { if (e.target === modal || e.target.classList.contains("vmodal__close")) close(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) close(); });
})();
